import React, { useState } from 'react';
import { Modal } from './ui/Modal';
export function Footer() {
  const [privacyOpen, setPrivacyOpen] = useState(false);
  const [termsOpen, setTermsOpen] = useState(false);
  return <>
      <footer className="bg-[#050505] py-12 border-t border-gray-900" data-id="element-31">
        <div className="max-w-5xl mx-auto px-4 flex flex-col md:flex-row items-center justify-between gap-4" data-id="element-32">
          <p className="text-gray-600 text-sm" data-id="element-33">
            Reset Mental Funcional (RMF) © 2026
          </p>
          <div className="flex items-center gap-6" data-id="element-34">
            <button onClick={() => setPrivacyOpen(true)} className="text-gray-600 hover:text-gray-400 text-sm transition-colors underline-offset-4 hover:underline" data-id="element-35">
              Política de Privacidad
            </button>
            <span className="text-gray-800" data-id="element-36">|</span>
            <button onClick={() => setTermsOpen(true)} className="text-gray-600 hover:text-gray-400 text-sm transition-colors underline-offset-4 hover:underline" data-id="element-37">
              Términos y Condiciones
            </button>
          </div>
        </div>
      </footer>

      {/* Privacy Policy Modal */}
      <Modal isOpen={privacyOpen} onClose={() => setPrivacyOpen(false)} title="Política de Privacidad" data-id="element-38">
        <p className="text-gray-400 text-xs uppercase tracking-wider mb-4" data-id="element-39">
          Última actualización: Febrero 2026
        </p>

        <h3 className="text-white font-bold text-base mb-2" data-id="element-40">
          1. Información que recopilamos
        </h3>
        <p data-id="element-41">
          Al adquirir Reset Operativo (7 Min), recopilamos únicamente la
          información necesaria para procesar tu compra: nombre, dirección de
          correo electrónico e información de pago. No almacenamos datos de
          tarjetas de crédito directamente — estos son procesados de forma
          segura por nuestro proveedor de pagos.
        </p>

        <h3 className="text-white font-bold text-base mb-2" data-id="element-42">
          2. Uso de la información
        </h3>
        <p data-id="element-43">Tu información se utiliza exclusivamente para:</p>
        <ul className="list-disc list-inside space-y-1 ml-2 text-gray-400" data-id="element-44">
          <li data-id="element-45">Procesar y entregar tu compra (PDF descargable)</li>
          <li data-id="element-46">
            Enviar comunicaciones relacionadas con tu producto (actualizaciones,
            soporte)
          </li>
          <li data-id="element-47">
            Enviar correos de seguimiento si te suscribiste voluntariamente
          </li>
        </ul>

        <h3 className="text-white font-bold text-base mb-2" data-id="element-48">
          3. Protección de datos
        </h3>
        <p data-id="element-49">
          Implementamos medidas de seguridad estándar de la industria para
          proteger tu información personal. Utilizamos conexiones cifradas
          (SSL/TLS) para todas las transacciones.
        </p>

        <h3 className="text-white font-bold text-base mb-2" data-id="element-50">
          4. Compartir información
        </h3>
        <p data-id="element-51">
          No vendemos, intercambiamos ni transferimos tu información personal a
          terceros, excepto a proveedores de servicios de confianza que nos
          asisten en la operación del sitio y el procesamiento de pagos, siempre
          que dichas partes acuerden mantener esta información confidencial.
        </p>

        <h3 className="text-white font-bold text-base mb-2" data-id="element-52">5. Cookies</h3>
        <p data-id="element-53">
          Utilizamos cookies básicas para mejorar la experiencia del usuario y
          analizar el tráfico del sitio. Puedes desactivar las cookies en la
          configuración de tu navegador.
        </p>

        <h3 className="text-white font-bold text-base mb-2" data-id="element-54">6. Tus derechos</h3>
        <p data-id="element-55">
          Puedes solicitar la eliminación de tus datos personales en cualquier
          momento. Para ejercer este derecho, envía una solicitud a través de
          los canales disponibles en nuestro sitio.
        </p>

        <h3 className="text-white font-bold text-base mb-2" data-id="element-56">
          7. Cambios a esta política
        </h3>
        <p data-id="element-57">
          Nos reservamos el derecho de actualizar esta política de privacidad en
          cualquier momento. Los cambios serán publicados en esta página con la
          fecha de actualización correspondiente.
        </p>
      </Modal>

      {/* Terms & Conditions Modal */}
      <Modal isOpen={termsOpen} onClose={() => setTermsOpen(false)} title="Términos y Condiciones" data-id="element-58">
        <p className="text-gray-400 text-xs uppercase tracking-wider mb-4" data-id="element-59">
          Última actualización: Febrero 2026
        </p>

        <h3 className="text-white font-bold text-base mb-2" data-id="element-60">
          1. Producto digital
        </h3>
        <p data-id="element-61">
          Reset Operativo (7 Min) es un producto digital (PDF) creado por Reset
          Mental Funcional (RMF). Al completar tu compra, recibirás acceso
          inmediato al archivo descargable.
        </p>

        <h3 className="text-white font-bold text-base mb-2" data-id="element-62">2. Uso personal</h3>
        <p data-id="element-63">
          El contenido de este producto es para uso personal exclusivamente.
          Queda prohibida la reproducción, distribución, modificación o reventa
          del material sin autorización expresa por escrito.
        </p>

        <h3 className="text-white font-bold text-base mb-2" data-id="element-64">
          3. Naturaleza del producto
        </h3>
        <p data-id="element-65">
          Este producto es una herramienta educativa y de productividad. No
          constituye asesoramiento médico, psicológico ni terapéutico. Si
          experimentas problemas de salud mental, consulta a un profesional
          calificado.
        </p>

        <h3 className="text-white font-bold text-base mb-2" data-id="element-66">
          4. Política de reembolso
        </h3>
        <p data-id="element-67">
          Debido a la naturaleza digital e inmediatamente descargable del
          producto, todas las ventas son finales. No se ofrecen reembolsos una
          vez que el archivo ha sido descargado. Si tienes problemas técnicos
          con la descarga, nos comprometemos a resolverlos.
        </p>

        <h3 className="text-white font-bold text-base mb-2" data-id="element-68">
          5. Limitación de responsabilidad
        </h3>
        <p data-id="element-69">
          Reset Mental Funcional (RMF) no se hace responsable de los resultados
          individuales obtenidos con el uso del producto. Los resultados pueden
          variar según la persona y su compromiso con la práctica.
        </p>

        <h3 className="text-white font-bold text-base mb-2" data-id="element-70">
          6. Propiedad intelectual
        </h3>
        <p data-id="element-71">
          Todo el contenido, incluyendo textos, gráficos, metodología R.O.C. y
          materiales asociados, es propiedad intelectual de Reset Mental
          Funcional (RMF) y está protegido por las leyes de derechos de autor
          aplicables.
        </p>

        <h3 className="text-white font-bold text-base mb-2" data-id="element-72">
          7. Modificaciones
        </h3>
        <p data-id="element-73">
          Nos reservamos el derecho de modificar estos términos en cualquier
          momento. Las modificaciones entrarán en vigor inmediatamente después
          de su publicación en el sitio.
        </p>

        <h3 className="text-white font-bold text-base mb-2" data-id="element-74">
          8. Ley aplicable
        </h3>
        <p data-id="element-75">
          Estos términos se rigen por las leyes de los Estados Unidos de
          América. Cualquier disputa será resuelta en los tribunales competentes
          de dicha jurisdicción.
        </p>
      </Modal>
    </>;
}